import { inject as I } from "vue";
import { g as V } from "../_baseGetTag-D86WGQCZ.js";
import { r as D } from "../toString-Cs_Mc-g1.js";
import { traverse as J, traverseBackwards as O } from "./tree.js";
import { E as f } from "../constants-xx4jN7Xb.js";
var l, F;
function W() {
  if (F) return l;
  F = 1;
  function r(e, n, t) {
    var i = -1, o = e.length;
    n < 0 && (n = -n > o ? 0 : o + n), t = t > o ? o : t, t < 0 && (t += o), o = n > t ? 0 : t - n >>> 0, n >>>= 0;
    for (var u = Array(o); ++i < o; )
      u[i] = e[i + n];
    return u;
  }
  return l = r, l;
}
var d, _;
function z() {
  if (_) return d;
  _ = 1;
  var r = W();
  function e(n, t, i) {
    var o = n.length;
    return i = i === void 0 ? o : i, !t && i >= o ? n : r(n, t, i);
  }
  return d = e, d;
}
var m, q;
function x() {
  if (q) return m;
  q = 1;
  var r = "\\ud800-\\udfff", e = "\\u0300-\\u036f", n = "\\ufe20-\\ufe2f", t = "\\u20d0-\\u20ff", i = e + n + t, o = "\\ufe0e\\ufe0f", u = "\\u200d", a = RegExp("[" + u + r + i + o + "]");
  function s(c) {
    return a.test(c);
  }
  return m = s, m;
}
var h, C;
function Y() {
  if (C) return h;
  C = 1;
  function r(e) {
    return e.split("");
  }
  return h = r, h;
}
var g, M;
function Z() {
  if (M) return g;
  M = 1;
  var r = "\\ud800-\\udfff", e = "\\u0300-\\u036f", n = "\\ufe20-\\ufe2f", t = "\\u20d0-\\u20ff", i = e + n + t, o = "\\ufe0e\\ufe0f", u = "[" + r + "]", a = "[" + i + "]", s = "\\ud83c[\\udffb-\\udfff]", c = "(?:" + a + "|" + s + ")", w = "[^" + r + "]", R = "(?:\\ud83c[\\udde6-\\uddff]){2}", T = "[\\ud800-\\udbff][\\udc00-\\udfff]", j = "\\u200d", A = c + "?", S = "[" + o + "]?", L = "(?:" + j + "(?:" + [w, R, T].join("|") + ")" + S + A + ")*", P = S + A + L, X = "(?:" + [w + a + "?", a, R, T, u].join("|") + ")", B = RegExp(s + "(?=" + s + ")|" + X + P, "g");
  function G(H) {
    return H.match(B) || [];
  }
  return g = G, g;
}
var b, E;
function K() {
  if (E) return b;
  E = 1;
  var r = Y(), e = x(), n = Z();
  function t(i) {
    return e(i) ? n(i) : r(i);
  }
  return b = t, b;
}
var v, U;
function Q() {
  if (U) return v;
  U = 1;
  var r = z(), e = x(), n = K(), t = D();
  function i(o) {
    return function(u) {
      u = t(u);
      var a = e(u) ? n(u) : void 0, s = a ? a[0] : u.charAt(0), c = a ? r(a, 1).join("") : u.slice(1);
      return s[o]() + c;
    };
  }
  return v = i, v;
}
var p, y;
function rr() {
  if (y) return p;
  y = 1;
  var r = Q(), e = r("toUpperCase");
  return p = e, p;
}
var er = rr();
const $ = /* @__PURE__ */ V(er);
function sr(r, e, n) {
  let t = !1;
  const i = window.performance.now(), o = () => {
    const c = (window.performance.now() - i) / e;
    if (c > 1) {
      n && n();
      return;
    }
    t || (r(c), window.requestAnimationFrame(o));
  };
  return window.requestAnimationFrame(o), () => t = !0;
}
function cr(r, e, n) {
  return Math.max(e, Math.min(r, n));
}
function fr(r) {
  if (!r) return "";
  switch (r[0]) {
    case "¿":
    case "¡":
      return r[0] + $(r.slice(1, r.length));
    default:
      return $(r);
  }
}
function lr(r) {
  return J(r, (e) => {
    if (k(e))
      return e.focus(), !0;
  });
}
function dr(r) {
  return O(r, (e) => {
    if (k(e))
      return e.focus(), !0;
  });
}
function k(r) {
  if (r.tabIndex > 0 || r.tabIndex === 0 && r.getAttribute("tabIndex") !== null)
    return !0;
  if (r.disabled)
    return !1;
  switch (r.nodeName) {
    case "A":
      return !!r.href && r.rel != "ignore";
    case "INPUT":
      return r.type != "hidden" && r.type != "file";
    case "BUTTON":
    case "SELECT":
    case "TEXTAREA":
      return !0;
    default:
      return !1;
  }
}
function mr(r, e, n, t = 0, i = 1) {
  return e + (r - t) * (n - e) / (i - t);
}
function hr(r) {
  if (r.length == 1) return { m: 0, b: r[0][1] };
  let e = 0, n = 0, t = 0, i = 0;
  for (let [a, s] of r)
    e += a, n += s, t += a * a, i += a * s;
  const o = (r.length * i - e * n) / (r.length * t - e * e), u = n / r.length - o * e / r.length;
  return { m: o, b: u };
}
function gr(r) {
  return r ? new window.DOMParser().parseFromString(r, "text/html").documentElement.textContent : "";
}
function br(r, { startOpacity: e = 0.3, endOpacity: n = 0.3 } = {}) {
  return e = Number(e), n = Number(n), r ? `linear-gradient(to bottom, rgba(0, 0, 0, ${e}), rgba(0, 0, 0, ${n})), url(${r})` : `linear-gradient(to bottom, rgba(0, 0, 0, ${e + 0.2}), rgba(0, 0, 0, ${n + 0.2}))`;
}
function N(r) {
  let e = Math.floor(r / 3600), n = Math.floor((r - 3600 * e) / 60), t = Math.floor(r - 3600 * e - n * 60);
  return {
    hours: e,
    mins: n,
    secs: t
  };
}
function vr(r) {
  if (r > 0) {
    const e = N(r), n = e.hours > 9 ? e.hours : "0" + e.hours, t = e.mins > 9 ? e.mins : "0" + e.mins, i = e.secs > 9 ? e.secs : "0" + e.secs;
    return `${n}:${t}:${i}`;
  } else
    return "00:00:00";
}
function pr(r) {
  if (r > 0) {
    const e = N(r), n = e.mins > 9 ? e.mins : "0" + e.mins, t = e.secs > 9 ? e.secs : "0" + e.secs;
    return `${n}:${t}`;
  }
  return "00:00";
}
async function wr({ response: r, fileName: e }) {
  if (!r.ok) {
    const t = I(
      "ftk.i18n.fileGenerationError",
      "Generation of the excel file has failed"
    );
    throw new Error(t);
  }
  const n = await r.blob();
  nr({ blob: n, fileName: e });
}
async function nr({ blob: r, fileName: e }) {
  const n = window.URL.createObjectURL(r), t = document.createElement("a");
  t.href = n, t.download = e, document.body.appendChild(t), t.click(), t.remove(), window.URL.revokeObjectURL(n);
}
function Rr(r) {
  if (r < 1024) return `${r.toFixed(2)} B`;
  const e = Math.floor(Math.log(r) / Math.log(1024)), n = "KMGTPE".charAt(e - 1);
  return `${(r / Math.pow(1024, e)).toFixed(0)} ${n}B`;
}
function Tr(r) {
  if (r = r.toLowerCase(), f.externalVideo.includes(r))
    return r;
  if (f.image.includes(r))
    return "image";
  if (f.video.includes(r))
    return "video";
  if (f.audio.includes(r))
    return "audio";
  if (f.text.includes(r))
    return "text";
  if (f.doc.includes(r))
    return "pdf";
  throw new Error(`Type ${r} has no player defined`);
}
export {
  sr as animate,
  cr as clamp,
  nr as downloadBlob,
  wr as downloadResponseFile,
  vr as fmtDigitalTimeHoursMinsSecs,
  pr as fmtDigitalTimeMinsSecs,
  lr as focusFirstFocusable,
  dr as focusLastFocusable,
  Rr as formatSize,
  Tr as guessPlayerFromExtension,
  gr as html2text,
  br as imageWithVeil,
  k as isFocusable,
  mr as lerp,
  hr as linearRegression,
  N as secsToHoursMinsSecs,
  fr as ucfirst
};
